<div class="nvb-utskrift-dialog">
  <div class="nvb-utskrift-content">
    @for (item of items; track item.title; let first = $first) {
      <div class="nvb-utskrift-item" [class.nvb-utskrift-page-break]="!first">
        <rask-header size="2" noPadding>{{item.title}}</rask-header>

        @if (isRiskbedomning(item)) {
          <rask-header size="3" noPadding>Riskbedömning av leveransvirke/leveransgrot: Övrig avverkning</rask-header>

          <table class="nvb-utskrift-table">
            <tbody>
              <tr>
                <td>Leverantören accepterar Sveaskogs policy om nyckelbiotoper/höga bevarandevärden</td>
                <td>{{jaNej(item.naturvardesbedomning?.leverantorAccepterarPolicy)}}</td>
              </tr>
              <tr>
                <td>Leverantören förstår gällande lagar och hur dessa påverkar avverkningsåtgärden</td>
                <td>{{jaNej(item.naturvardesbedomning?.leverantorKontrolleratLaguppfyllnad)}}</td>
              </tr>
              <tr>
                <td>Leverantören kan redogöra för var och vilken träråvara som avverkas</td>
                <td>{{jaNej(item.naturvardesbedomning?.leverantorKontrolleratAvverkning)}}</td>
              </tr>
              <tr>
                <td>Fältbesök krävs</td>
                <td>{{jaNej(item.naturvardesbedomning?.faltbesokKravs)}}</td>
              </tr>
              @if (item.naturvardesbedomning?.faltbesokKravs) {
                <tr>
                  <td>Fältbesök genomfört</td>
                  <td>{{item.naturvardesbedomning?.faltbesokDatum ?? "-"}}</td>
                </tr>
              }
              <tr>
                <td>Träråvaran uppfyller Sveaskogs ursprungskrav på inköp</td>
                <td>{{jaNej(item.naturvardesbedomning?.naturvardesbedomningUtford)}}</td>
              </tr>
            </tbody>
          </table>
        } @else {
          @let variantConfig = getVariantConfig(item);

          <rask-header size="3" noPadding>Naturvärdesbedömning - {{variantConfig?.label}}</rask-header>

          <table class="nvb-utskrift-table">
            <thead>
              <tr>
                <th>Naturvärden</th>
                <th>Antal per ha</th>
                <th>Högt naturvärde</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Naturvärdesträd</td>
                <td>{{item.naturvardesbedomning?.naturvardestradTotalPerHa ?? "-"}}</td>
                <td>{{jaNej(item.naturvardesbedomning?.naturvardestrad)}}</td>
              </tr>
              @if (variantConfig?.visaNaturvardestradTrsl) {
                <tr>
                  <td>Naturvärdesträd, enskilt trädslag</td>
                  <td>{{item.naturvardesbedomning?.naturvardestradTrslPerHa ?? "-"}}</td>
                  <td></td>
                </tr>
              }
              <tr>
                <td>Naturvärdesträd av hög kvalitet</td>
                <td>{{item.naturvardesbedomning?.naturvardestradKvalitetTotalPerHa ?? "-"}}</td>
                <td>{{jaNej(item.naturvardesbedomning?.naturvardestradKvalitet)}}</td>
              </tr>
              <tr>
                <td>Död ved</td>
                <td>{{item.naturvardesbedomning?.dodVedTotalPerHa ?? "-"}}</td>
                <td>{{jaNej(item.naturvardesbedomning?.dodVed)}}</td>
              </tr>
              @if (variantConfig?.visaDodVedTrsl) {
                <tr>
                  <td>Död ved, enskilt trädslag</td>
                  <td>{{item.naturvardesbedomning?.dodVedTrslPerHa ?? "-"}}</td>
                  <td></td>
                </tr>
              }
              <tr>
                <td>Död ved av hög kvalitet</td>
                <td>{{item.naturvardesbedomning?.dodVedKvalitetTotalPerHa ?? "-"}}</td>
                <td>{{jaNej(item.naturvardesbedomning?.dodVedKvalitet)}}</td>
              </tr>
              @if (variantConfig?.visaDodVedKvalitetTrsl) {
                <tr>
                  <td>Brand-/silverstubbar</td>
                  <td>{{item.naturvardesbedomning?.dodVedKvalitetTrslPerHa ?? "-"}}</td>
                  <td></td>
                </tr>
              }
              <tr>
                <td>Ålder (snittålder minst {{variantConfig?.aldersgrans}} år)</td>
                <td>-</td>
                <td>{{jaNej(item.naturvardesbedomning?.alder)}}</td>
              </tr>
              <tr>
                <td>Kontinuitet</td>
                <td>-</td>
                <td>{{jaNej(item.naturvardesbedomning?.kontinuitet)}}</td>
              </tr>
              <tr>
                <td>Trädslag (bristträdslag)</td>
                <td>-</td>
                <td>{{jaNej(item.naturvardesbedomning?.tradslag)}}</td>
              </tr>
              <tr>
                <td>Hänsynskrävande biotop</td>
                <td>-</td>
                <td>{{jaNej(item.naturvardesbedomning?.hansynskravandeBiotop)}}</td>
              </tr>
            </tbody>
          </table>

          <div class="nvb-utskrift-summering">
            <span class="label">Summering naturvärden</span>
            <span>{{getNaturvardeSummering(item)}}</span>
          </div>

          <rask-header size="3" noPadding>Övriga värden</rask-header>

          <table class="nvb-utskrift-table">
            <tbody>
              <tr>
                <td>Känd förekomst av naturvårdsarter</td>
                <td>{{jaNej(item.naturvardesbedomning?.kandForekomstNaturvardesarter)}}</td>
              </tr>
              <tr>
                <td>Känd förekomst av forn- eller kulturlämningar</td>
                <td>{{jaNej(item.naturvardesbedomning?.kandForekomstFornKulturlamn)}}</td>
              </tr>
              <tr>
                <td>Värdefull för friluftsliv och rekreation</td>
                <td>{{jaNej(item.naturvardesbedomning?.skogVardefullFriluftsklivRekreation)}}</td>
              </tr>
              <tr>
                <td>Kräver samråd med rennäring</td>
                <td>{{jaNej(item.naturvardesbedomning?.viktigForRennaring)}}</td>
              </tr>
            </tbody>
          </table>

          <div class="nvb-utskrift-row">
            <span>Hänsyn till miljövärden tas genom</span>
            <span>{{item.naturvardesbedomning?.hansynMiljovarden ?? "-"}}</span>
          </div>
          <div class="nvb-utskrift-row">
            <span>Kompletterande information</span>
            <span>{{item.naturvardesbedomning?.kompletterandeInformation ?? "-"}}</span>
          </div>
          <div class="nvb-utskrift-row">
            <span>Naturvärdesbedömning gjord på</span>
            <span>{{bedomningPa(item)}}</span>
          </div>
          <div class="nvb-utskrift-row">
            <span>Naturvärdesbedömning utförd</span>
            <span>{{jaNej(item.naturvardesbedomning?.naturvardesbedomningUtford)}}</span>
          </div>
        }

        @if (item.naturvardesbedomning?.naturvardesbedomningUtford) {
          <div class="nvb-utskrift-row">
            <span>Utförd av</span>
            <span>{{item.naturvardesbedomning?.utfordAv ?? "-"}}</span>
          </div>
          <div class="nvb-utskrift-row">
            <span>Utförd datum</span>
            <span>{{item.naturvardesbedomning?.utfordDatum ? (item.naturvardesbedomning.utfordDatum | date:'yyyy-MM-dd') : "-"}}</span>
          </div>
        }
      </div>
    } @empty {
      <p>Ingen naturvärdesbedömning att visa.</p>
    }
  </div>

  <div class="no-print nvb-utskrift-footer d-flex justify-content-end gap-2">
    <rask-button color="primary" icon="fas fa-print" (click)="print()">Skriv ut</rask-button>
    <rask-button color="secondary" (click)="close()">Stäng</rask-button>
  </div>
</div>
